import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-icon-new-conversation',
    templateUrl: './icon-new-conversation.component.html'
})
export class IconNewConversationComponent implements OnInit {

    constructor() { }

    ngOnInit() {
    }

}
